import { render } from "./IconNotif.vue?vue&type=template&id=47947340"
const script = {}

import exportComponent from "E:\\salekWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__